import api from './client';
export const notificationService = {
    getNotifications: async () => {
        const response = await api.get('/api/v1/notifications');
        return response.data.data;
    },
    markAsRead: async (id) => {
        const response = await api.patch(`/api/v1/notifications/${id}/read`);
        return response.data.data;
    },
    markAllAsRead: async () => {
        await api.patch('/api/v1/notifications/read-all');
    },
};
